import styled from "@emotion/styled";
import { Container } from "@mui/material";
import React from "react";
import Heading from "../../components/Heading";

import bh from "../../images/bh.png";
import gsm from "../../images/gsm.png";
import nova from "../../images/nova.png";

const Wrapper = styled.div`
  padding-top: 100px;
  padding-bottom: 100px;
  text-align: center;
  @media (max-width: 599px) {
    padding-top: 50px;
    padding-bottom: 60px;
  } ;
`;
const Cells = styled.div`
  text-align: center;
  padding-top: 50px;
  //   padding-bottom:50px;
  display: flex;
  justify-content: space-between;
`;
const Img = styled.div`
  filter: grayscale(1);
  &:hover {
    filter: none;
    transform: translate(0%, 0%) scale(0.9);
    transition: 0.2s ease-in;
  }
  @media (max-width: 1399px) {
    filter: none;
    transform: scale(0.9);
    &:hover {
      filter: none;
      transition: none;
    }
  } ;
`;

const index = () => {
  return (
    <div>
      <Container>
        <Wrapper>
          <Heading ta="center"> Development Partners</Heading>
          <Cells>
            <Img>
              <img className="img-fluid" src={bh} />
            </Img>
            <Img>
              <img style={{ paddingTop: 10 }} className="img-fluid" src={gsm} />
            </Img>
            <Img>
              <img className="img-fluid" src={nova} />
            </Img>
          </Cells>
        </Wrapper>
      </Container>
    </div>
  );
};

export default index;
